import { hasFeatureCanary, WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { FeatureFlag } from 'Environment/FeatureFlag';

export class FeatureCanaryConfigAccessor {
	private workspaceConfiguration: WorkspaceConfiguration;

	public constructor(workspaceConfiguration: WorkspaceConfiguration) {
		this.workspaceConfiguration = workspaceConfiguration;
	}

	public isFeatureEnabled(featureFlag: FeatureFlag): boolean {
		return hasFeatureCanary(this.workspaceConfiguration, featureFlag);
	}
}
